import { useState, useEffect, useRef } from "react";
import { createModel } from "hox";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useDtpDetailModel } from "../dtpDetailModel";
import { enquiryService } from "../../../dtpService";
import { publicService } from "@/views/public/publicService";
import { message } from "antd";
import { IBillLadingDetail } from "../../../dtpTypes";
import moment from "moment";


export const useExtractModel = createModel(function () {
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedRow, setSelectedRow] = useState<IBillLadingDetail>({});
    const [fileList, setFileList] = useState<any[]>([]);
    const { getTreeNodeName } = useDictModel(() => []);
    const { editFormVal } = useDtpDetailModel();

    useEffect(() => {
        let filters = fileList.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as any)
    }, [selectedRowKeys]);

    const getFileList = async () => {
        let params = {
            page: {
                pageSize: 1000,
                pageNum: 1,
            },
            code: editFormVal.code
        }
        let { retData } = await enquiryService.billLadingPage(params)
        const { records, ...pg } = retData;
        console.log(records)
        setFileList((records ?? []).map(item => ({
            ...item,
            key: item.id,
            checkTime: item.checkTime ? moment(item.checkTime) : null,
            approveTime: item.approveTime ? moment(item.approveTime) : null,
        })))
    }
    //删除文件
    const removeFile = async (fileId: string) => {
        let { retData } = await enquiryService.billLadingDelete(fileId);
        message.success("删除成功");
        getFileList();
    }
    const upLoadCallback = async (file: File & { response: { retData: string } }) => {
        console.log(file)
        if (file) {
            let { retData } = await publicService.insertFile({
                code: editFormVal.code,
                "name": file.name,
                "md5": file?.response.retData
            });
            let { retData: billLadingData } = await enquiryService.billLadingInsert({
                "code": editFormVal.code,
                "name": file.name,
                "typeCode": file.type,
                "typeName": file.type,
                "md5": file?.response.retData,
            })
            getFileList()
        }
    }
    const billLadingUpdate = async (record: IBillLadingDetail) => {
        if(!record.billCode) {
           return message.warning("请输入该条信息对应的提单编号");
        }
        console.log(record)
        let { retData: billLadingData } = await enquiryService.billLadingUpdate({
            "id": record.id as string,
            "code": record.code as string,
            "name": record.name as string,
            "typeCode": record.type as string,
            "typeName": record.type as string,
            "md5": record.type as string,
            "billCode":record.billCode as string,
            "checkTime": record.checkTime ? moment(record.checkTime).format("YYYY-MM-DD HH:mm:ss") : null,
            "approveTime": record.approveTime ? moment(record.approveTime).format("YYYY-MM-DD HH:mm:ss") : null,
        })
        message.success("提单编号保存成功");
        getFileList()
    }
    return {
        selectedRowKeys, setSelectedRowKeys,
        fileList, setFileList,
        removeFile,
        upLoadCallback,
        selectedRow, setSelectedRow,
        billLadingUpdate,
        
    }
});